import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../custom/components/Text-Input/TextInput.js";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput.js";
import CustomForm from "../../../custom/Forms/CustomForm.js";
import {
  dropdownData,
  getRecords,
  saveRecords,
} from "../../../services/api.service.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../../custom/Utils/UseCreateFormUtils.js";
import { createPageData } from "./ItemFile.js";
import { basicFormData } from "./ItemFile.js";
import { validate } from "../../../custom/validations/Validate.js";
import SelectInput from "../../../custom/components/Select-Input/SelectInput.js";

const ItemCreate = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    originData,
    itemType,
    categoryPayload,
  } = createPageData();
  const [loadingData, setLoadingData] = useState(false);
  const [costOption, setCostOption] = useState(false);
  const initialPayload = useMemo(() => payload, []);

  const {
    formData,
    setFormData,
    onInputChange,
    formErrors,
    setFormErrors,
    handleSelectChange,

    selectedDropOption,
    selectedDropdownOptions,
    setSelectedDropOption,
    setSelectedUserOption,
    selectedUserOption,
  } = useCreateForm(
    getEndpoint,
    id,
    initialPayload,
    basicFormData(),
    validationType,
    dependentDropdownData
  );
  const [selectOriginOption, setSelectOrignOption] = useState("");
  const [selectItemTypeOption, setSelectItemTypeOption] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [selectCategoryOption, setSelectCategoryOption] = useState("");

  const setSelectedOption = (options, value, setSelected) => {
    const matchedOption = options.find((option) => option.value == value);
    setSelected(
      matchedOption
        ? { label: matchedOption.label, value: matchedOption.value }
        : null
    );
  };
  useEffect(() => {
    if (originData.length) {
      setSelectedOption(
        originData[0]?.options,
        formData.inputData.origin,
        setSelectOrignOption
      );
    }
  }, [formData.inputData.origin]);

  useEffect(() => {
    if (itemType.length) {
      setSelectedOption(
        itemType[0]?.options,
        formData.inputData.type,
        setSelectItemTypeOption
      );
    }
  }, [formData.inputData.type]);

  useEffect(() => {
    if (selectedDropdownOptions.length) {
      setSelectedOption(
        selectedDropdownOptions[0]?.options,
        formData.inputData.uom_id,
        setSelectedDropOption
      );
    }
  }, [formData.inputData.uom_id, selectedDropdownOptions]);
  useEffect(() => {
    if (categoryList.length) {
      setSelectedOption(
        categoryList[0]?.options,
        formData.inputData.category_id,
        setSelectCategoryOption
      );
    }
  }, [formData.inputData.category_id, categoryList, selectCategoryOption]);
  useEffect(() => {
    const getCategoryOptions = async () => {
      try {
        const responseData = await getRecords(categoryPayload, "/listCategory");
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "category_name",
          "category_id",
          false
        );

        setCategoryList(dropdownResponseData);
      } catch (error) {
        console.error("Error fetching category options:", error);
      }
    };
    getCategoryOptions();
  }, []);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails") || {});
    const role = userDetails?.role_masters?.role_name;
    if (role?.toLowerCase() === "cost user".toLowerCase()) {
      setCostOption(true);
    } else {
      setCostOption(false);
    }
  }, []);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);
      const validationErrors = validate(validationType, formData.inputData);

      let updatedErrors = { ...validationErrors };
      if (costOption == false) {
        delete updatedErrors.cost;
      }
      if (Object.keys(updatedErrors).length > 0) {
        setLoadingData(false);

        setFormErrors(updatedErrors);
        return;
      }
      const isCreating = !id;
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));

      const payload = {
        id,
        modelName: initialPayload?.modelName,
        inputData: {
          ...formData.inputData,
          created_by: isCreating
            ? userDetails.id
            : formData.inputData.created_by,
          updated_by: userDetails.id,
        },
      };

      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      if (responseData && responseData.code == 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData?.message ||
            `Error while ${id ? "updating" : "saving"} ${headerName}!`
        );
      }
    } catch (error) {
      console.log("err", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  const handleOriginSelectChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    const fieldError = validate("ItemCreate", {
      origin: selectedValue,
    });
    setSelectOrignOption(selectedOption);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      origin: fieldError["origin"] || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        origin: selectedOption ? selectedOption?.value : "",
      },
    }));
  };
  const handleItemTypeSelectChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    const fieldError = validate("ItemCreate", {
      type: selectedValue,
    });
    setSelectItemTypeOption(selectedOption);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      type: fieldError["type"] || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        type: selectedOption ? selectedOption?.value : "",
      },
    }));
  };

  const handleCategorySelectChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";
    const fieldError = validate("ItemCreate", {
      category_id: selectedValue,
    });
    setSelectCategoryOption(selectedOption);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      category_id: fieldError["category_id"] || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        category_id: selectedOption ? selectedOption?.value : "",
      },
    }));
  };
  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <TextInput
            label="item code"
            name="item_code"
            value={formData.inputData.item_code}
            onChange={onInputChange}
            placeholder="item code"
            inputClassName="form-control "
            labelClassName="form-label"
            autocomplete={"off"}
            customError={formErrors.item_code}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Description"
            name="description"
            value={formData.inputData.description}
            onChange={onInputChange}
            placeholder="Description"
            inputClassName="form-control "
            labelClassName="form-label"
            autocomplete={"off"}
            customError={formErrors.description}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="UOM"
            name="uom_id"
            value={selectedDropOption}
            options={selectedDropdownOptions}
            onSelect={handleSelectChange}
            placeholder="Select UOM"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.uom_id}
            asterisk={true}
          />
        </Col>
        {costOption && (
          <Col md="6" className="mt-3">
            <TextInput
              label="Cost"
              name="cost"
              value={formData.inputData.cost}
              onChange={onInputChange}
              placeholder="Cost"
              inputClassName="form-control "
              labelClassName="form-label"
              autocomplete={"off"}
              customError={costOption && formErrors.cost}
              asterisk={true}
            />
          </Col>
        )}

        <Col md="6" className="mt-3">
          <SelectInput
            label="Origin"
            name="origin"
            value={selectOriginOption}
            options={originData}
            onSelect={handleOriginSelectChange}
            placeholder="Select Origin"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.origin}
            asterisk={true}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Type"
            name="type"
            value={selectItemTypeOption}
            options={itemType}
            onSelect={handleItemTypeSelectChange}
            placeholder="Select Type"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.type}
            asterisk={true}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="Category"
            name="category_id"
            value={selectCategoryOption}
            options={categoryList}
            onSelect={handleCategorySelectChange}
            placeholder="Select Category"
            parentClassName=""
            selectClassName=""
            labelClassName="form-label"
            parentStyle={{}}
            selectStyle={{}}
            labelStyle={{}}
            size={1}
            noDataMessage="data not found"
            maxMenuHeight={200}
            isClearable={false}
            customError={formErrors.category_id}
            asterisk={true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col lg="12">
          <CheckboxInput
            label="Is Active"
            name="is_active"
            value={formData.inputData.is_active}
            checked={formData.inputData.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
            disabled={false}
            required={false}
            customError={formErrors.is_active}
          />
        </Col>
      </Row>
    </CustomForm>
  );
};
export default ItemCreate;
